import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/src/ScrollTrigger';
import { headerToggle } from './homeAnimations';
gsap.registerPlugin(ScrollTrigger);

export const menuColorChange = () => {
  const sectionsDark = gsap.utils.toArray('.menu-light');
  if (sectionsDark.length) {
    sectionsDark.forEach((section) => {
      const animationLength = section.offsetHeight - 5;
      ScrollTrigger.create({
        start: 'top 10%',
        end: '+=' + animationLength,
        trigger: section,
        toggleClass: 'text-white',
        onEnter: () => headerToggle(true),
        onLeave: () => headerToggle(),
        onEnterBack: () => headerToggle(true),
        onLeaveBack: () => headerToggle(),
        // markers: true,
      });
    });
  }
};

export const brandBanner = () => {
  const brandInfo = document.querySelector('.brand-info');
  if (brandInfo) {
    gsap.to('.banner img', {
      scrollTrigger: {
        trigger: '.banner',
        start: 'top top',
        scrub: true,
      },
      y: 150,
      duration: 10,
    });
  }
};

export const backToBrand = () => {
  const backTo = document.querySelector('.back-to-brands');
  if (backTo) {
    gsap.set(backTo, { height: 0 });
    gsap.to(backTo, {
      scrollTrigger: {
        trigger: backTo,
        start: 'top 70%',
      },
      height: 'auto',
      duration: 1,
    });
  }
};

export const brandReveal = () => {
  const brandList = document.querySelector('.brand-list');
  if (!brandList || window.innerWidth > 620) {
    return;
  }
  const listItems = gsap.utils.toArray(
    '.brand-list__item .brand-list-content__load',
  );
  listItems.forEach((item) => {
    gsap.to(item, {
      scrollTrigger: {
        trigger: item,
        start: 'top 50%',
        end: '20% top',
        toggleActions: 'restart reset reverse reset',
      },
      opacity: 0,
      duration: 0.25,
    });
    // gsap.to(item, {
    //   scrollTrigger: {
    //     trigger: item,
    //     start: 'bottom 40%',
    //     markers: true,
    //     scrub: true,
    //   },
    //   opacity: 1,
    //   duration: 0.25,
    // });
  });
};
